
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Footer',
  data() {
    return {
      links: {
        jhonny: 'http://instagram.com/colorcontradiction',
        vue: 'https://vuejs.org/',
      }
    };
  },
  computed: {
    year() {
      return new Date().getUTCFullYear();
    }
  }
});
